import { Components, Theme } from '@mui/material'

const MuiList: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      background: theme.backgrounds.backgroundFour,
      border: `1px solid ${theme.backgrounds.backgroundOne}`,
      boxShadow: theme.boxShadows.small,
      borderRadius: 14,
      display: 'flex',
      flexWrap: 'wrap',
    }),
    padding: ({ theme }) => ({
      background: theme.backgrounds.backgroundFour,
      border: `1px solid ${theme.backgrounds.backgroundOne}`,
      boxShadow: theme.boxShadows.small,
      borderRadius: 14,
    }),
  },
}

export default MuiList
